<template>
	<div class="header">
		<ul class="left">
			<li @click="show2hide">
				<i class="icon iconfont icon-caidan"></i>
			</li>

		</ul>
		<ul class="right">
			<li>
				<el-dropdown trigger="click" @command="nameEvent">
					<span class="el-dropdown-link" style="display: block;">
    					{{info.nickname}}
  					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item class="clearfix" command="logout">

							<i class="el-icon-bell"></i>
							<span>退出</span>

						</el-dropdown-item>

					</el-dropdown-menu>
				</el-dropdown>
			</li>
			<!--
            
			<li>
				<el-dropdown trigger="click">
					<span class="el-dropdown-link" style="display: block;">
    						<i style="font-size: 1.1rem;" class="el-icon-bell"></i>		
  					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item class="clearfix">

							<i class="el-icon-bell"></i>
							<span>消息</span>
							<el-badge style="line-height: 1.4rem;" class="mark" :value="9" />
						</el-dropdown-item>

					</el-dropdown-menu>
				</el-dropdown>

			</li>
			-->

		</ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				info: {}
			}
		},
		created() {
			this.getInfo()
		},
		methods: {
			//显示或隐藏导航
			show2hide() {
				this.$store.commit('show2hide')
			},
			//获取信息
			getInfo() {

				var obj = this
				var loading = obj.$layer.loading(1);
				this.$ajax({
					method: 'get',
					url: global.url + '/developer/user/myinfo'

				}).then(function(res) {
					obj.$layer.close(loading)
					if(res.data.error === 0) {
						obj.info = res.data.data.info
						//obj.$store.commit('updateAdminInfo', obj.admin_info)
					} else {
						obj.$layer.msg(res.data.msg)
					}

				}).catch(function(res) {
					obj.$layer.close(loading)
					obj.$layer.msg('网络错误')
				})

			},
			nameEvent(command) {
				if(command == 'logout') {
					this.$layer.msg('退出成功')
					this.$cookies.remove('user_token')
					this.$router.push({
						path: '/login'
					})
				}

			}
		}
	}
</script>

<style scoped>
	.header {
		line-height: 56px;
		overflow: hidden;
	}
	
	.header .left {}
	
	.header .left li {
		float: left;
		cursor: pointer;
		padding: 0rem 1rem;
	}
	
	.header .left li i {
		font-size: 1.1rem;
		line-height: 56px;
	}
	
	.header .right {}
	
	.header .right li {
		float: right;
		cursor: pointer;
		padding: 0rem 1rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/common/Header.vue